<template>
  <div style="width: 100%">
    <div class="spaces-filter-container">
      <div class="top-bar-left">
        <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
        <Checkbox @change="onFilterChanged" v-model="checked['Online']" id="filter-in-progress"
                  title="Online"></Checkbox>
        <Checkbox @change="onFilterChanged" v-model="checked['Desktop']" id="filter-in-progress"
                  title="Desktop"></Checkbox>
        <Checkbox @change="onFilterChanged" v-model="checked['Mobile']" id="filter-checked"
                  title="Mobile"></Checkbox>
        <Checkbox @change="onFilterChanged" v-model="checked['Tablet']" id="filter-built-in"
                  title="Tablet"></Checkbox>
        <AdaButton style="margin-left: auto" title="REFRESH" type="createButton blue" @click="refresh()"></AdaButton>
      </div>
    </div>
    <AdaDatatable v-if="!loading" :scroll="true" :columns="columns" :data="rows" :show-search="false"
                  :size-of-page="10000"
                  @rowClicked="cellClicked" :search-value="searchValue" :table-filters="[tableFilter]"
                  disable-pagination :transformers="transformers"></AdaDatatable>
    <div v-else class="loaderContainer">
      <dot-loader id="loader"></dot-loader>
    </div>
  </div>
</template>

<script>
import AdaDatatable from "../../components/tables/AdaDatatable";
import InputSearch from "../../components/inputs/InputSearch";
import moment from 'moment';
//import Transformers from "../../components/tables/Transformers";
import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Checkbox from "../../components/inputs/Checkbox";
import AdaButton from "../../components/buttons/AdaButton";

const CampaignRepository = RepositoryFactory.get('campaigns');

export default {
  components: {
    AdaButton,
    AdaDatatable,
    InputSearch,
    Checkbox
  },
  data: function () {
    return {
      loading: false,
      tableFilter: {
        propName: 'target_medium',
        allowedValues: []
      },
      checked: {
        "Online": false,
        "Desktop": false,
        "Mobile": false,
        "Tablet": false
      },
      searchValue: '',
      columns: [
        {
          viewName: 'Medium',
          propName: 'name',
          sortable: true,
          width: '550px',
          maxWidth: '550px'
        },
        {
          viewName: 'Typ',
          propName: 'type',
          sortable: true,
          width: '100px',
          maxWidth: '100px'
        },
        {
          viewName: 'Laufzeit',
          propName: 'duration',
          width: '220px',
          maxWidth: '220px'
        },
        {
          viewName: 'Aktion',
          propName: 'action',
          width: '220px',
          maxWidth: '220px'
        }
      ],
      rows: [],
      transformers: [
        {
          propName: 'action',
          transform: function (value) {
            let res = '';
            value.forEach(action => {
              switch (action) {
                case 'select':
                  res += '<button data-type="select" class="select-button">Trackingliste laden</button>';
                  break;
                default:
                  console.error('default case');
              }
            });
            return res;
          }
        },
        {
          propName: 'type',
          transform: function (value) {
            let res = '';
            switch (value.toLowerCase()) {
              case 'online':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-xdigital"></span>';
                break;
              case 'desktop':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-desktop"></span>';
                break;
              case 'mobile':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-mobile"></span>';
                break;
              case 'tablet':
                res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-tablet"></span>';
                break;
            }
            return res;
          }
        }
      ]
    }
  },
  name: "SelectTrackingListFromMedium",
  mounted() {
    this.fetchTrackingLists();
  },
  methods: {
    onFilterChanged: function () {
      this.runFilter();
    },
    runFilter: function () {
      let allowedValues = [];
      for (let key in this.checked) {
        if (this.checked[key]) {
          allowedValues.push(key);
        }
      }
      this.tableFilter.allowedValues = allowedValues;
    },
    cellClicked: function (data) {
      let dataType = data.target.getAttribute('data-type');
      switch (dataType) {
        case 'select':
          this.selectedTrackingList = data.row;
          this.$emit('selectedTrackingList', this.selectedTrackingList);
          break;
      }
    },
    async fetchTrackingLists() {
      this.loading = true;
      let currentTrackinglistID = parseInt(this.$route.params.trackinglist_id);
      let id = this.$store.getters['trackingList/campaign'].id;
      const {data} = await CampaignRepository.getCampaign(id, true);
      let rows = [];
      data.mediums.forEach((medium) => {
        if (medium.tracking_list_id !== null && currentTrackinglistID !== medium.tracking_list_id) {
          medium.action = [
            'select'
          ];
          let date = this.getDuration(medium);
          medium.duration = '';
          if (date.min.isSame(date.max, 'day')) {
            let start = date.min.format('DD.MM.YYYY');
            medium.duration += start;
          } else {
            let start = date.min.format('DD.MM.YYYY');
            if (date.min.isSame(date.max, 'year')) {
              start = date.min.format('DD.MM.');
            }
            let end = date.max.format('DD.MM.YYYY');
            medium.duration += start + ' - ' + end;
          }
          let type = medium.type.charAt(0).toUpperCase() + medium.type.slice(1).toLowerCase();
          let name = medium.name || '';
          medium.name = type + ' ' + name;
          medium.name = medium.name.trim();
          medium.selectedFromMedium = true;
          rows.push(medium);
        }
      });
      this.loading = false;
      this.rows = rows;
    },
    getDuration(medium) {
      let minDate, maxDate;
      let dates = [];
      console.log('getduration')
      medium.insertion_order.forEach((order) => {
        order.dates.forEach((date) => {
          dates.push(moment(date.start, 'YYYY-MM-DD'));
          dates.push(moment(date.end, 'YYYY-MM-DD'));
        })
      });
      maxDate = moment.max(dates);
      minDate = moment.min(dates);
      return {min: minDate, max: maxDate}
    },
    refresh() {
      this.fetchTrackingLists();
    },
  }
}
</script>

<style lang="scss" scoped>
.top-bar-left {
  display: flex;
  align-items: center;
  width: 100%;
}

.spaces-filter-container {
  width: 100%;
  background-color: white;
  height: 50px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
}

.tab-list {
  margin-bottom: 20px;
}

.loaderContainer {
  height: 20vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep tbody tr td:nth-child(2) {
  padding: 0 15px !important;

  span[class*='icon-']:before {
    top: 4px;
    position: relative;
  }
}

</style>